import { Dispatch, RefObject, SetStateAction, useEffect } from 'react'

const useOutsideClick = (ref: RefObject<HTMLDivElement>, stateSetter: Dispatch<SetStateAction<boolean>>): void => {
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  useEffect(() => {
    const handleClickOutside = (event: any): void => {
      if (ref.current && !ref.current.contains(event.target)) {
        isMobile && stateSetter(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, stateSetter])
}

export default useOutsideClick
